import { PIMAccordionDetails } from './PIMAccordionDetails';

export default PIMAccordionDetails;
